<template>
  <section>
    <span :class="type" class="badge"
      ><slot>{{ text }}</slot></span
    >
  </section>
</template>

<script>
export default {
  props: ["type", "title"],
  computed: {
    text() {
      return this.title.toUpperCase();
    },
  },
};
</script>


<style scoped>
.badge {
  background-color: #71008d;
  color: #fff;
  border-radius: 30px;
  padding: 0.2rem 1rem;
  font-size:13px;
  display: inline-block;
  margin-right: 0.5rem;
}
section {
  display: inline-block;
  margin-top: 5px;
  margin-right: 5px;
}
.start{background:green;}
.hold{background:red;}
.finish{background:salmon;}
</style>